import feathersClient, {makeServicePlugin, BaseModel} from '../../feathers-client'

class GalleryItem extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'GalleryItem';

    // Define default properties here
    static instanceDefaults() {
        return {
            fGalleryId: null,
            photo: null,
            src: null,
            description: null,
            order: -1,
            isShown: 1,
        }
    }
}

const servicePath = 'f-gallery-photos';
const servicePlugin = makeServicePlugin({
    Model: GalleryItem,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin